// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

// Components
import Editable from '../../Editable';

export default class PageSplit extends React.Component {

    insertSplitter = () => {
        let split = [...this.props.split];
        const page = this.props.pageIdx;

        //If any of the splits not in toNext format, convert them and deduplicate
        split = convertAndDeduplicate(split, this.props.documentName + " (UNSPLIT)")

        // If a page splitter already exists here, don't do anything
        if (!(split.find(g => g.pages && g.pages.length > 0 && g.pages[0] === page))){
            // Insert splitter
            split.push({
                pages: [page],
                toNext: true,
                name: this.props.documentName + ' - Page ' + String(page)
            });
        }

        this.props.setSplit(split);
    }

    getSplitOnPage = () => {
        if (!this.props.split) return;
        for (const group of this.props.split)
            if (group.pages && group.pages.length > 0 && group.pages[0] === this.props.pageIdx)
                return group;
        return null;
    }

    editGroupName = (name) => {
        let split = [...this.props.split];
        for (const group of split)
            if (group.pages && group.pages.length > 0 && group.pages[0] === this.props.pageIdx)
                group.name = name;

        this.props.setSplit(split);
    }

    removeSplit = () => {
        let split = [...this.props.split];
        const groupIdx = split.findIndex(group => (group.pages && group.pages.length > 0 && group.pages[0] === this.props.pageIdx));

        if (groupIdx >= 0)
            split.splice(groupIdx, 1);

        this.props.setSplit(split);
    }

    render = () => {
        const splitOnPage = this.getSplitOnPage(this.props.pageIdx);
        return (<div
            className={"document-page-splitter" + (splitOnPage ? " document-page-splitter-active" : "")}
            style={{
                width: "calc(" + this.props.zoom + " * (78vh - 60px) + 40px)",
            }}
            title={splitOnPage ? "" : "Insert a page splitter here"}
            onClick={splitOnPage ? () => { } : this.insertSplitter}
        >
            <div className="document-page-splitter-dash" />

            {splitOnPage && <>
                {/* Split page name */}
                <Editable
                    className="document-page-splitter-name"
                    inputClass="document-page-splitter-name-edit"
                    valueClass="document-page-splitter-name-value"
                    fieldName="New Document Name"
                    value={splitOnPage.name}
                    editable={true}
                    setValue={this.editGroupName}
                />

                <div
                    className="document-page-splitter-cancel"
                    title="Remove page splitter"
                    onClick={this.removeSplit}
                />
            </>}
        </div>);
    }

};

function convertAndDeduplicate(split, unsplit_key) {

    let result = {}
    let unsplit = { 0: unsplit_key }
    split.forEach(element => {
        if (element.toNext) {
            if (element.pages && element.pages.length > 0 && !result[element.pages[0]]) {
                result[element.pages[0]] = element.name;
            }
        }
    });
    split.forEach(element => {
        if (!element.toNext && element.pages) {
            element.pages.forEach(val => {
                if (!result[val]) {
                    result[val] = element.name;
                }
                if (!unsplit[val + 1]) {
                    unsplit[val + 1] = unsplit_key
                }
            })
        }
    });
    for (const [key, value] of Object.entries(unsplit)) {
        if (!result[key]) {
            result[key] = value
        }
    }
    let new_split = []
    // convert to array as long as pages are not too big
    for (const [key, value] of Object.entries(result)) {
        if (key >= 0) {
            new_split.push({
                "toNext": true,
                "pages": [ parseInt(key) ],
                "name": value
            })
        }
    }
    // sort
    new_split.sort((a, b) => a['pages'][0] - b['pages'][0])
    // remove any unneccesary entries in range with each other
    new_split = new_split.filter((c, index) => {
        if (index > 0) {
            return new_split[index - 1].name !== new_split[index].name;
        } else {
            return true
        }
    });
    return new_split
}